import React from "react";

export default function RegistrationSvgIcon({ xml, width, height }) {
  return (
    <span
      className="registration-svg-icon"
      aria-hidden="true"
      style={{ width, height }}
      dangerouslySetInnerHTML={{ __html: xml }}
    />
  );
}
